import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { convertDate } from "../../functions";

export interface IServiceDetailsProps {
  activeService?: {
    resetTrafficDateTime?: Date;
    serviceTitle: string;
    endDateTime: Date;
  };
}

const ServiceDetails = ({ activeService }: IServiceDetailsProps) => {
  if (!activeService) return null;

  return (
    <>
      <tr>
        <td>
          <FontAwesomeIcon icon="caret-square-right" className="text-blue" />
        </td>
        <td className="text-95 text-600 text-secondary-d2">سرویس جاری</td>
        <td className="text-dark-m3 text-wrap">{activeService.serviceTitle}</td>
      </tr>
      <tr>
        <td>
          <FontAwesomeIcon icon={["far", "clock"]} className="text-secondary" />
        </td>
        <td className="text-95 text-600 text-secondary-d2">اتمام سرویس</td>
        <td className="text-dark-m3">
          {convertDate(activeService.endDateTime)}
        </td>
      </tr>
      {activeService.resetTrafficDateTime && (
        <tr>
          <td>
            <FontAwesomeIcon icon="history" className="text-secondary" />
          </td>
          <td className="text-95 text-600 text-secondary-d2">ریست ترافیک</td>
          <td className="text-dark-m3">
            {convertDate(activeService.resetTrafficDateTime) || "---"}
          </td>
        </tr>
      )}
    </>
  );
};

export default ServiceDetails;
